var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"token"},[_c('h1',[_vm._v("Sono 10 giorni che manca la connessione internet ...")]),_c('img',{attrs:{"src":(_vm.publicPath + "img/intro/ubisell-logo.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }